/**
 * Created by Languagenut on 16/04/2019.
 */

import React  from 'react';
import {Breadcrumb} from 'react-bootstrap'
import { Verbs , Sentence  , Summary , GradeBook , Highscores  , Exam} from '../reports';
import Gammar from '../reports/grammar.js';

import ProductStore from '../../store/product-store.js';
import ProductService from '../../services/product-service.js';
import Constants from '../../constants.js';
import Translation from '../../store/internationalization-store.js';
export default class Reports extends React.Component {

    constructor(props) {
        super();
        this.props = props;

        this.state = {
            report:this.props.selectedReport,
            reportTitle:this.props.reportTitle,
        };
    }
    componentWillMount() {
        ProductService.getAllLanguages();
        ProductStore.on(Constants.GET_LANGUAGES ,  ()=>{
            this.setState({update:true})
        });
    }

    componentWillReceiveProps(props){

        this.props = props;
        this.setState({
            report:this.props.selectedReport,
        })

    }

    handleSelect(eventKey){
        this.setState({tab:eventKey})
    }

    onClick(){
        this.setState({
            toggle:!this.state.toggle,
        })
    }

    getBody()
    {
        switch(this.state.report)
        {
            default: return <Summary classLanguages={this.props.classLanguages} language={this.props.language} classID={this.props.classID} />
            case "exam"   : return <Exam language={this.props.language} screen={this.props.screenID} classID={this.props.classID}/>
            case "vocabs"   : return <GradeBook language={this.props.language} screen={this.props.screenID} classID={this.props.classID}/>
            case "custom"   : return <GradeBook language={this.props.language} screen={this.props.screenID} classID={this.props.classID}/>
            case "highscores": return <Highscores language={this.props.language} classID={this.props.classID}/>
            case "verbs" : return <Verbs language={this.props.language} screen={this.props.screenID}  classID={this.props.classID}/>
            case "sentences" : return <Sentence language={this.props.language} screen={this.props.screenID}  classID={this.props.classID}/>
            case "grammar" : return <Gammar language={this.props.language} screen={this.props.screenID}  classID={this.props.classID}/>
        }
    }


    getBreadCrumb(){
        switch(this.state.report)
        {
            default: return null;
            case "exam"   : return Translation.get(12128 , 'Exams');
            case "vocabs": 
            if (window.languagenutAdminTitle != undefined && window.languagenutAdminTitle != "") {
                return window.languagenutAdminTitle;
            }
            return Translation.get(12233 , 'Vocabulary');

            case "highscores": return Translation.get(12625 , 'High scores');
            case "verbs" : return Translation.get(1026 , 'Verbs');
            case "sentences" : return Translation.get(12626 , 'Sentences');
            case "grammar" : return Translation.get(100 , 'Grammar');
        }
    }

    render(){
        var languageName = "";
        if (this.props.language != undefined) {
            var languages = ProductStore.getLearningLanguages();
            for (var i =0; i < languages.length; i++) {
                if (languages[i].ietf == this.props.language) {
                    languageName = Translation.get(languages[i].name); 
                }
            }
        }

        let crmb = <Breadcrumb.Item active>{languageName}</Breadcrumb.Item>
        if(!this.props.language) crmb = null;

        let crmb2 = null;

        if(this.getBreadCrumb()) crmb2 = <Breadcrumb.Item active>{this.getBreadCrumb()}</Breadcrumb.Item>

        console.log('here')

        return <div>
            <Breadcrumb>
                <Breadcrumb.Item href={"#/classes/reports/"+this.props.classID}>{Translation.get(12627 , 'Reports Summary')}</Breadcrumb.Item>
                {crmb}
                {crmb2}
            </Breadcrumb>
            {this.getBody()}
        </div>
    }
}
